import React from 'react';
import './Holidays.css';

import Icon from '../../../components/Icon/Icon';

const holidays = ( props ) => (
	<section id="Holidays">
		<h2>Holidays</h2>
		<p>
			We also get paid Federal holidays (long weekends FTW!). If you have a heavy workload, you may be able to work some of these holidays and bank the hours instead. Talk to your supervisor for more information.
		</p>
		<div className="holiday-lists">
			<Icon icon="benefits.holiday1" />
			<div className="holiday-group">
				<div className="holiday-list">
					<p>New Year's Day</p>
					<p className="bankable">President's Day</p>
					<p className="bankable">MLK Day</p>
				</div>
				<div className="holiday-list">
					<p className="bankable">Memorial Day</p>
					<p className="bankable">Independence Day</p>
					<p className="bankable">Labor Day</p>
					<p className="bankable">Columbus Day</p>
				</div>
				<div className="holiday-list">
					<p className="bankable">Veterans Day</p>
					<p>Thanksgiving Day</p>
					<p>Christmas Day</p>
				</div>
			</div>
			<Icon icon="benefits.holiday2" />
		</div>
	</section>
);

export default holidays;



// WEBPACK FOOTER //
// ./src/pages/Benefits/Holidays/Holidays.js